/**
 * Shipping policy: zones (CABA and Greater Buenos Aires within 48 h, elsewhere arranged on WhatsApp),
 * WhatsApp coordination, packaging. Free shipping paragraphs only show while it is switched on.
 */
import type { InfoDoc } from "../types";

export const shipping: InfoDoc = {
  es: {
    title: "Envíos",
    intro: "Cómo, cuándo y a dónde: todo lo que tenés que saber para recibir tus cartas.",
    sections: [
      {
        title: "CABA y Gran Buenos Aires: dentro de las 48 horas",
        paragraphs: [
          "Enviamos a CABA y a los tres cordones del Gran Buenos Aires, y despachamos tu pedido dentro de las 48 horas de acreditado el pago. El envío se paga junto con la compra:",
          "CABA: {rate:caba}. 1er cordón (Avellaneda, Lanús, Lomas de Zamora, La Matanza, Morón, San Isidro, Vicente López, San Martín y Tres de Febrero): {rate:cordon1}.",
          "2do cordón (Quilmes, Berazategui, Florencio Varela, Almirante Brown, Esteban Echeverría, Ezeiza, Merlo, Moreno, José C. Paz, Malvinas Argentinas, San Miguel, San Fernando, Tigre, Hurlingham e Ituzaingó): {rate:cordon2}.",
          "3er cordón (Escobar, Pilar, General Rodríguez, Marcos Paz, Presidente Perón, San Vicente, Cañuelas, La Plata, Berisso, Ensenada, Zárate, Campana, Exaltación de la Cruz, Luján, General Las Heras y Brandsen): {rate:cordon3}.",
          "Al elegir tu ciudad en el checkout te sugerimos la zona y te mostramos el costo antes de pagar.",
          "{if:free}Envío gratis a {freeZones} en compras desde {freeMin}.",
        ],
      },
      {
        title: "Resto del país",
        paragraphs: [
          "{if:noother}¿Estás en otra zona? Hacé tu pedido igual: coordinamos el envío con vos por WhatsApp (empresa de correo, costo y plazo).",
          "{if:other}Enviamos a todo el país por correo: {rate:other}, se paga junto con la compra. Te pasamos el número de seguimiento cuando lo despachamos.",
        ],
      },
      {
        title: "Te contactamos por WhatsApp",
        paragraphs: [
          "Al comprar te pedimos un teléfono: te escribimos por WhatsApp a ese número para confirmar la dirección y coordinar la entrega. Podés dejarlo guardado en Mi cuenta, junto con tu dirección, para no cargarlo cada vez.",
          "Cuando despachamos el pedido te avisamos por email, con el número de seguimiento si corresponde.",
        ],
      },
      {
        title: "Cómo viajan las cartas",
        paragraphs: [
          "Cada carta va en su sleeve (funda), y las de más de US$ 10 además en un toploader rígido, para que no se doblen, no se marquen y no se ensucien en el camino. Los productos sellados viajan tal como salen de fábrica, bien protegidos dentro de la caja.",
        ],
      },
      {
        title: "Si algo llega mal",
        paragraphs: [
          "Revisá el paquete al recibirlo. Si algo llegó dañado, falta o no coincide con lo publicado, avisanos lo antes posible a {email} con fotos y lo resolvemos. Más detalles en la [[/reembolsos|política de reembolsos]].",
        ],
      },
    ],
  },
  en: {
    title: "Shipping",
    intro: "How, when and where: everything you need to know to get your cards.",
    sections: [
      {
        title: "Buenos Aires City and Greater Buenos Aires: within 48 hours",
        paragraphs: [
          "We ship to Buenos Aires City (CABA) and the three rings of Greater Buenos Aires, and dispatch your order within 48 hours of the payment going through. Shipping is paid with the order:",
          "CABA: {rate:caba}. 1st ring (Avellaneda, Lanús, Lomas de Zamora, La Matanza, Morón, San Isidro, Vicente López, San Martín and Tres de Febrero): {rate:cordon1}.",
          "2nd ring (Quilmes, Berazategui, Florencio Varela, Almirante Brown, Esteban Echeverría, Ezeiza, Merlo, Moreno, José C. Paz, Malvinas Argentinas, San Miguel, San Fernando, Tigre, Hurlingham and Ituzaingó): {rate:cordon2}.",
          "3rd ring (Escobar, Pilar, General Rodríguez, Marcos Paz, Presidente Perón, San Vicente, Cañuelas, La Plata, Berisso, Ensenada, Zárate, Campana, Exaltación de la Cruz, Luján, General Las Heras and Brandsen): {rate:cordon3}.",
          "When you choose your city at checkout we suggest the area and show the cost before you pay.",
          "{if:free}Free shipping to {freeZones} on orders from {freeMin}.",
        ],
      },
      {
        title: "Rest of the country",
        paragraphs: [
          "{if:noother}Somewhere else? Place your order anyway: we arrange the shipping with you on WhatsApp (carrier, cost and timing).",
          "{if:other}We ship anywhere in Argentina by post: {rate:other}, paid with the order. We send you the tracking number when it ships.",
        ],
      },
      {
        title: "We reach you on WhatsApp",
        paragraphs: [
          "At checkout we ask for a phone number: we message you on WhatsApp there to confirm the address and arrange delivery. You can save it in My account, with your address, so you don't type it every time.",
          "When we ship the order we email you, with the tracking number when there is one.",
        ],
      },
      {
        title: "How the cards travel",
        paragraphs: [
          "Every card goes in its sleeve, and those over US$10 also in a rigid toploader, so they don't bend, get marked or dirty on the way. Sealed products travel as they come from the factory, well protected inside the box.",
        ],
      },
      {
        title: "If something arrives wrong",
        paragraphs: [
          "Check the parcel when it arrives. If something is damaged, missing or doesn't match the listing, let us know as soon as possible at {email} with photos and we'll fix it. See the [[/reembolsos|refund policy]].",
        ],
      },
    ],
  },
};
